import React, { useEffect, useState } from 'react';
import styles from './RewardModal.module.scss';
import Modal from '../Modal/Modal';
import { TelegramSticker } from '@/components/TelegramSticker';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
import { useNotificationStore } from '@/store/NotificationStore';
import { claimReward, getReward } from '@/api/modules/Login/login';

interface WalletModalProps {
  open: boolean;
  onClose: () => void;
  rewardData: any; // Теперь это одна награда, а не массив
}

const RewardModal: React.FC<WalletModalProps> = ({
  open,
  onClose,
  rewardData,
}) => {
  const tg = window?.Telegram?.WebApp;
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const [loading, setLoading] = useState(false);

  // Функция для обработки текста с HTML-тегами <br/>
  const processTextWithBreaks = (text: string) => {
    if (!text) return '';
    return text.split('<br/>').map((part, index, array) => (
      <React.Fragment key={index}>
        {part}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ));
  };
  const handleBonus = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const claim = await claimReward(rewardData.id);
      console.log(claim, 'claim');
      if (claim.message === 'Reward claimed successfully') {
        setNotification({
          type: 'Success',
          message: 'Награда получена!',
          rewards: [
            {
              amount: rewardData.rewards.amount,
              type: rewardData.rewards.type,
            },
          ],
        });
        // Обновляем баланс после успешного получения награды
        window.dispatchEvent(new Event('bonus-received'));
        onClose();
      } else {
        setNotification({
          type: 'Error',
          message: 'Ошибка получения награды!',
        });
        onClose();
        return;
      }
    } catch {
      setNotification({
        type: 'Error',
        message: 'Ошибка получения награды!',
      });
      onClose();
    } finally {
      setLoading(false);
      onClose();
    }
  };

  if (!open || !rewardData) return null;

  return (
    <Modal open={open} onClose={onClose} noCross={true} disableClose={true}>
      <div className={styles.walletModal}>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./handWinner.tgs"
            style={{ width: 120, height: 120 }}
            loop={true}
            autoplay={true}
          />
        </div>
        <h2 className={styles.title}>
          {processTextWithBreaks(rewardData.details.title)}
        </h2>
        <p className={styles.description}>{rewardData.details.description}</p>
        <div className={styles.balanceInfo}>
          <div className={styles.balanceItem}>
            <span className={styles.value}>
              {' '}
              {rewardData.rewards.amount} <StarIcon />{' '}
            </span>
          </div>
        </div>
        <button
          disabled={loading}
          onClick={handleBonus}
          className={styles.withdrawButton}
        >
          Забрать награду
        </button>
      </div>
    </Modal>
  );
};

export default RewardModal;
